(function () {
  'use strict';

  var rootPrefix = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---- Smooth anchor scrolling ---- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---- Image Gallery ---- */
  var mainImg = document.getElementById('fso-main-img');
  var thumbs = document.querySelectorAll('.fso-gallery__thumb');
  var images = [];
  var currentIndex = 0;

  thumbs.forEach(function (thumb, i) {
    var img = thumb.querySelector('img');
    if (img) {
      images.push(img.getAttribute('data-full') || img.src);
    }
    thumb.addEventListener('click', function () {
      setActiveImage(i);
    });
  });

  function setActiveImage(i) {
    if (!mainImg || i < 0 || i >= images.length) return;
    currentIndex = i;
    mainImg.src = images[i];
    thumbs.forEach(function (t, j) {
      t.classList.toggle('is-active', j === i);
    });
  }

  var prevBtn = document.getElementById('fso-prev');
  var nextBtn = document.getElementById('fso-next');
  if (prevBtn) prevBtn.addEventListener('click', function () {
    setActiveImage((currentIndex - 1 + images.length) % images.length);
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    setActiveImage((currentIndex + 1) % images.length);
  });

  /* ---- Tab Switching ---- */
  var tabBtns = document.querySelectorAll('.fso-tabs__btn');
  var tabPanels = document.querySelectorAll('.fso-tab-panel');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tab = btn.getAttribute('data-tab');
      tabBtns.forEach(function (b) { b.classList.remove('is-active'); });
      tabPanels.forEach(function (p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var panel = document.getElementById('fso-tab-' + tab);
      if (panel) panel.classList.add('is-active');
    });
  });

  /* ---- Format price with Dutch comma separator ---- */
  function formatDutchPrice(total) {
    return '\u20AC' + total.replace('.', ',');
  }

  /* ---- Quantity Selector ---- */
  var qtyCards = document.querySelectorAll('.fso-qty-card');
  var ctaPriceEls = document.querySelectorAll('.fso-cta-price');
  var initialSelected = document.querySelector('.fso-qty-card.is-selected');
  var selectedQty = initialSelected ? (parseInt(initialSelected.getAttribute('data-qty'), 10) || 1) : 1;

  /* Format initial price on page load */
  if (initialSelected) {
    var initTotal = initialSelected.getAttribute('data-total') || '';
    if (initTotal) {
      ctaPriceEls.forEach(function (el) { el.textContent = formatDutchPrice(initTotal); });
    }
  }

  qtyCards.forEach(function (card) {
    card.addEventListener('click', function () {
      qtyCards.forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      var total = card.getAttribute('data-total') || '';
      selectedQty = parseInt(card.getAttribute('data-qty'), 10) || 1;
      variantId = card.getAttribute('data-variant-id') || variantId;
      ctaPriceEls.forEach(function (el) { if (total) el.textContent = formatDutchPrice(total); });
      updateCtaLinks();
    });
  });

  /* ---- Sync CTA <a> links with selected quantity ---- */
  var ctaLinks = document.querySelectorAll('a.fso-btn');
  ctaLinks.forEach(function (a) { a.setAttribute('data-base-href', a.getAttribute('href') || ''); });

  function updateCtaLinks() {
    ctaLinks.forEach(function (a) {
      var base = a.getAttribute('data-base-href') || '';
      if (!base || base.charAt(0) === '#') return;
      var parts = base.split('?');
      var params = new URLSearchParams(parts[1] || '');
      params.set('qty', selectedQty);
      a.setAttribute('href', parts[0] + '?' + params.toString());
    });
  }
  updateCtaLinks();

  /* ---- Add to Cart & Checkout ---- */
  var purchaseEl = document.getElementById('purchase');
  var selectedCard = document.querySelector('.fso-qty-card.is-selected');
  var variantId = (selectedCard && selectedCard.getAttribute('data-variant-id'))
    || (purchaseEl ? purchaseEl.getAttribute('data-variant-id') : '');
  var isSubmitting = false;

  function addToCartAndCheckout() {
    if (!variantId) {
      console.warn('Offer: Geen product geselecteerd in sectie-instellingen.');
      return;
    }
    if (isSubmitting) return;
    isSubmitting = true;

    var atcBtns = document.querySelectorAll('.fso-atc-btn');
    atcBtns.forEach(function (btn) {
      btn.disabled = true;
      btn.classList.add('fso-atc-btn--loading');
    });

    /* Clear cart first to prevent stacking */
    fetch(rootPrefix + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(function () {
      return fetch(rootPrefix + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }]
        })
      });
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Toevoegen aan winkelwagen mislukt');
      return res.json();
    })
    .then(function () {
      /* Add shipping protection silently before checkout redirect */
      if (window.rcSpVariantId) {
        window._rcSpAdded = true; /* Prevent rc-shipping-protection.js auto-add from duplicating */
        return fetch(rootPrefix + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: window.rcSpVariantId, quantity: 1 }] })
        }).catch(function () { /* SP unavailable — ignore */ });
      }
    })
    .then(function () {
      window.location.href = rootPrefix + 'checkout';
    })
    .catch(function (err) {
      console.error('ATC fout:', err);
      isSubmitting = false;
      atcBtns.forEach(function (btn) {
        btn.disabled = false;
        btn.classList.remove('fso-atc-btn--loading');
      });
    });
  }

  document.querySelectorAll('.fso-atc-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCartAndCheckout();
    });
  });

  /* ---- Sale Bar Countdown (to midnight +2 days) ---- */
  function updateSaleCountdown() {
    var now = new Date();
    var end = new Date(now);
    end.setDate(end.getDate() + 2);
    end.setHours(23, 59, 59, 0);
    var diff = end - now;
    if (diff <= 0) diff = 0;
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var dEl = document.getElementById('fso-cd-d');
    var hEl = document.getElementById('fso-cd-h');
    var mEl = document.getElementById('fso-cd-m');
    var sEl = document.getElementById('fso-cd-s');
    if (dEl) dEl.textContent = pad(d);
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }
  updateSaleCountdown();
  setInterval(updateSaleCountdown, 1000);

  /* ---- Urgency Timer (session-based, 5 min) ---- */
  var urgencyEl = document.getElementById('fso-urgency-timer');
  if (urgencyEl) {
    var urgencyEnd = Date.now() + 5 * 60 * 1000;
    var stored = sessionStorage.getItem('fso_urgency_end');
    if (stored && parseInt(stored) > Date.now()) {
      urgencyEnd = parseInt(stored);
    } else {
      sessionStorage.setItem('fso_urgency_end', urgencyEnd);
    }
    function updateUrgency() {
      var diff = urgencyEnd - Date.now();
      if (diff <= 0) diff = 0;
      var m = Math.floor(diff / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      urgencyEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    updateUrgency();
    setInterval(updateUrgency, 1000);
  }

  /* ---- Sticky Mobile CTA ---- */
  var stickyCta = document.getElementById('fso-sticky-cta');
  if (stickyCta && purchaseEl) {
    var stickyLast = -1;
    function updateSticky() {
      var show = (window.pageYOffset || document.documentElement.scrollTop || 0) > window.innerHeight * 0.4;
      var rect = purchaseEl.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) show = false;
      var val = show ? 1 : 0;
      if (val !== stickyLast) {
        stickyCta.classList.toggle('is-visible', show);
        stickyLast = val;
      }
      requestAnimationFrame(updateSticky);
    }
    requestAnimationFrame(updateSticky);
  }
})();
